import { useState } from 'react'

import SwapSettingModal from '@/components/modals/swap-setting-modal'
import { PATH_NAME } from '@/config'
import SettingButton from '@/containers/home/settings/SettingButton'
import { useTradePersistStore } from '@/store'

import { useLocation } from 'react-router-dom'

export function SwapSetting() {
  const { pathname } = useLocation()
  const [openSetting, setOpenSetting] = useState(false)
  const shouldShowSetting = [PATH_NAME.SWAP, PATH_NAME.HOME, PATH_NAME.FIXED_SWAP].includes(pathname)
  const isFixedSwap = pathname === PATH_NAME.FIXED_SWAP
  const { isBridge } = useTradePersistStore()
  if (!shouldShowSetting) return null
  return (
    <div className='flex items-center justify-between'>
      <SettingButton onClick={() => setOpenSetting(true)} isFixedSwap={isFixedSwap} isBridge={isBridge} />
      <SwapSettingModal
        isOpen={openSetting}
        onClose={() => setOpenSetting(false)}
        isFixedSwap={isFixedSwap}
        isBridge={isBridge}
      />
    </div>
  )
}
